import React, { Component } from "react";
import { convertFromHTML, ContentState, EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';


export default class Editors extends Component {
  constructor(props) {
    super(props);
    const contentBlocks = convertFromHTML(this.props.text);
    const contentState = ContentState.createFromBlockArray(contentBlocks);

    const editorState = EditorState.createWithContent(contentState);
    this.state = {
      editorState
    };
  }
  componentDidMount() {
    console.log(this.props.text)
    if (document.querySelector(".demo-toolbar-absolute")) {
      const toolbars = document.querySelectorAll(".demo-toolbar-absolute");
      for (let i = 0; i < toolbars.length; i++) {
        toolbars[i].style.height = "0px";
        toolbars[i].style.marginTop = "-15px";
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(prevProps.text.length !== this.props.text.length){
      const contentBlocks = convertFromHTML(this.props.text);
      const contentState = ContentState.createFromBlockArray(contentBlocks);
  
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState
      };
    }
  }

  onEditorStateChange = editorState => {
    this.setState({
      editorState
    });
    var data = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    console.log(data)
    this.props.onTextChange(data)
  };

  onContentStateChange = (contentState) => {
    // this.props.data.saveData(contentState, this.props.data.number, this.props.data.type, this.props.editorId)
    this.setState({
      contentState,
    });
  };

  onInitEditor = e => {
    const toolbar =
      e.target.parentElement.parentElement.parentElement.parentElement
        .firstChild;
    setTimeout(() => {
      if (toolbar.style.visibility == "visible") {
        toolbar.style.height = "unset";
      }
    }, 10);
  };
  
  onDestroy = e => {
    const toolbar =
      e.target.parentElement.parentElement.parentElement.parentElement
        .firstChild;

    setTimeout(() => {
      if (toolbar.style.visibility == "hidden") {
        toolbar.style.height = "0px";
      }
    }, 10);
  };

   uploadImageCallBack = (file) => {
    return new Promise(
      (resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.imgur.com/3/image');
        xhr.setRequestHeader('Authorization', 'Client-ID XXXXX');
        const data = new FormData();
        data.append('image', file);
        xhr.send(data);
        xhr.addEventListener('load', () => {
          const response = JSON.parse(xhr.responseText);
          resolve(response);
        });
        xhr.addEventListener('error', () => {
          const error = JSON.parse(xhr.responseText);
          reject(error);
        });
      }
    );
  }

  render() {
    const { editorState } = this.state;
    return (
      <div className="editor-container" >
        {/* <div className="editor-delete text-white">
          <i class="fas fa-times"></i>
        </div> */}
        <Editor
          toolbarClassName="demo-toolbar-absolute"
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          defaultEditorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          toolbarOnFocus
          toolbar={{
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true },
            image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
          }}
          onFocus={this.onInitEditor}
          onBlur={this.onDestroy}
          onContentStateChange={this.onContentStateChange}
        />
         {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        /> */}
      </div>
    );
  }
}
